module.exports = __webpack_public_path__ + "media/application/images/ask-banner@2x-ee5fe551c0bcd51d56246a8e98ba02c8dbe4a6e7c981173e64c22bb8e220ff32.png";